import { ACCESS_TOKEN_KEY } from "@iso/constants/common.constant";
import { API_ENDPOINTS } from "@iso/constants/apiEndpoints.constant";
import BaseService from "./base.service";

const appendScheduleFields = (formData, data) => {
  if (data.type !== undefined && data.type !== null) {
    formData.append("type", data.type);
  }
};

export default class CrawlingSettingService extends BaseService {
  search = (params) => {
    const searchParams = new URLSearchParams();
    Object.keys(params || {}).forEach((key) => {
      const value = params[key];
      if (value === null || value === undefined || value === "") {
        return;
      }
      if (Array.isArray(value)) {
        if (value.length === 0) {
          return;
        }
        value.forEach((item) => {
          if (item !== null && item !== undefined && item !== "") {
            searchParams.append(key, item);
          }
        });
        return;
      }
      searchParams.append(key, value);
    });
    return this.axios.get(API_ENDPOINTS.CRAWLING_SETTINGS_SEARCH, {
      params: searchParams,
    });
  };

  getDetail = ({ crawlingSettingId }) => {
    return this.axios.get(
      API_ENDPOINTS.CRAWLING_SETTINGS_DETAIL.replace(
        "{crawlingSettingId}",
        crawlingSettingId
      )
    );
  };

  getSettingFile = () => {
    return this.axios.get(API_ENDPOINTS.CRAWLING_SETTINGS_GET_SETTING_FILE);
  };

  deleteSettingFile = () => {
    return this.axios.get(
      API_ENDPOINTS.CRAWLING_SETTINGS_DELETE_SETTING_FILE_DRAFT
    );
  };

  validateSettingFile = (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return this.axios.post(
      API_ENDPOINTS.CRAWLING_SETTINGS_VALIDATE_SETTING_FILE,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN_KEY),
        },
      }
    );
  };

  create = (data) => {
    const formData = new FormData();
    if (data.file) {
      formData.append("file", data.file);
    }
    formData.append("title", data.title);
    formData.append("executionType", data.executionType);
    appendScheduleFields(formData, data);
    return this.axios.post(API_ENDPOINTS.CRAWLING_SETTINGS_CREATE, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN_KEY),
      },
    });
  };

  update = (data) => {
    return this.axios.put(
      API_ENDPOINTS.CRAWLING_SETTINGS_UPDATE.replace(
        "{crawlingSettingId}",
        data.crawlingSettingId
      ),
      data
    );
  };

  delete = ({ crawlingSettingId }) => {
    return this.axios.delete(
      API_ENDPOINTS.CRAWLING_SETTINGS_DELETE.replace(
        "{crawlingSettingId}",
        crawlingSettingId
      )
    );
  };

  execute = ({ crawlingSettingId, forceQueue }) => {
    return this.axios.post(
      API_ENDPOINTS.CRAWLING_SETTINGS_EXECUTE.replace(
        "{crawlingSettingId}",
        crawlingSettingId
      ),
      { forceQueue: !!forceQueue }
    );
  };

  cancel = ({ crawlingSettingId }) => {
    return this.axios.post(
      API_ENDPOINTS.CRAWLING_SETTINGS_CANCEL.replace(
        "{crawlingSettingId}",
        crawlingSettingId
      )
    );
  };

  getCurrent = ({ crawlingSettingId }) => {
    return this.axios.get(
      API_ENDPOINTS.CRAWLING_SETTINGS_CURRENT.replace(
        "{crawlingSettingId}",
        crawlingSettingId
      )
    );
  };

  getHistories = ({ crawlingSettingId }) => {
    return this.axios.get(
      API_ENDPOINTS.CRAWLING_SETTINGS_HISTORIES.replace(
        "{crawlingSettingId}",
        crawlingSettingId
      )
    );
  };

  importExcel = ({ crawlingSettingId, file }) => {
    const formData = new FormData();
    formData.append("file", file);
    return this.axios.post(
      API_ENDPOINTS.CRAWLING_SETTINGS_IMPORT.replace(
        "{crawlingSettingId}",
        crawlingSettingId
      ),
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN_KEY),
        },
      }
    );
  };
}
